import React, { Component, Fragment } from "react";
import Banner from "../Banner/Banner";
import Categories from "../Categories/Categories";
import Stories from "./Stories/Stories";
import Tiles from "./Tiles/Tiles";
import SpecialOffers from "./SpecialOffers/SpecialOffers";
import Suggestions from "./Suggestions/Suggestions";
import BestSellers from "./BestSellers/BestSellers";
import Newest from "./Newest/Newest";
import withRouter from "../withRouter/withRouter";

import "./Main.css";

const Connection = new (require("../../classes/Connection").default)();

class Main extends Component {
    state = {
        main_page_banners: [],
        categories: [],
        specialOffers: [],
        suggestions: [],
        bestSellers: [],
        bestSellers: [],
        newest: [],
    };

    constructor(props) {
        super(props);
        this.toast = this.props.toast;

        this.error_in_retrieving_data =
            this.error_in_retrieving_data.bind(this);
    }

    componentDidMount() {
        Connection.get_main_page_Banners()
            .then((res) => {
                this.setState({ main_page_banners: res.data });
            })
            .catch(this.error_in_retrieving_data);

        Connection.get_all_categories()
            .then((res) => {
                this.setState({ categories: res.data });
            })
            .catch(this.error_in_retrieving_data);

        Connection.get_all_special_offers()
            .then((res) => {
                this.setState({ specialOffers: res.data.items });
            })
            .catch(this.error_in_retrieving_data);

        Connection.get_all_suggestions()
            .then((res) => {
                this.setState({ suggestions: res.data.items });
            })
            .catch(this.error_in_retrieving_data);

        Connection.get_best_sellers(20)
            .then((res) => {
                this.setState({ bestSellers: res.data.items });
            })
            .catch(this.error_in_retrieving_data);
        Connection.get_newest_items(20)
            .then((res) => {
                this.setState({ newest: res.data.items });
            })
            .catch(this.error_in_retrieving_data);

        Connection.get_stories()
            .then((res) => {
                this.setState({ stories: res.data });
            })
            .catch(this.error_in_retrieving_data);
        Connection.get_tiles()
            .then((res) => {
                this.setState({ tiles: res.data });
            })
            .catch(this.error_in_retrieving_data);
    }

    error_in_retrieving_data(err) {
        this.toast("  خطا", "خطا در دریافت اطلاعات : " + err, " danger");

        this.props.router.navigate("/");
    }

    render() {
        let {
            main_page_banners,
            categories,
            specialOffers,
            suggestions,
            newest,
            stories,
            tiles,
            bestSellers,
        } = this.state;
        return (
            <Fragment>
                {main_page_banners.length > 0 && (
                    <Banner banners={main_page_banners} />
                )}
                {stories && stories.length > 0 && <Stories stories={stories} />}

                {categories.length > 0 && (
                    <Categories categories={categories} />
                )}
                {tiles && <Tiles structure={tiles} container={true} />}

                {specialOffers.length > 0 && (
                    <SpecialOffers specialOffers={specialOffers} />
                )}
                {newest.length > 0 && <Newest newest={newest} />}
                {suggestions.length > 0 && (
                    <Suggestions suggestions={suggestions} />
                )}
                {bestSellers.length > 0 && (
                    <BestSellers bestSellers={bestSellers} />
                )}
            </Fragment>
        );
    }
}

export default withRouter(Main);
